import React from 'react';
import './PromosBody.css';
import EmailFormSE from '../../components/EmailFormSE/EmailFormSE';
import useMediaQuery from '../../../hooks/useMediaQuery';

const PromosBody = ({
  title,
  headline,
  picURL,
  backgroundPic1,
  backgroundPic2,
  textColorDesktop,
  textColorMobile,
  campaignName,
  translations
}) => {
  const isUnder800 = useMediaQuery('(max-width: 800px)');

  return (
    <div className="rewards-body-container-main">
      <div className="rewards-body-container">
        <div
          className="reward-body-item"
          id="body-photo-rewards"
          style={{ backgroundImage: `url(${backgroundPic1})` }}
        ></div>
        <div
          className="reward-body-item"
          style={{ backgroundImage: isUnder800 ? `url(${backgroundPic2})` : '' }}
        >
          <h2
            className="rewards-headline-text"
            style={{ color: isUnder800 ? textColorMobile : textColorDesktop }}
          >
            {headline}
          </h2>
          {picURL && <img id="promo-image" src={picURL} alt={title} />}
          <br />
          <br />
          <div>
            <EmailFormSE
              picURL={picURL}
              pageType="promos"
              campaignName={campaignName}
              translations={translations}
            />
            <div className="disclaimer3">
              *VID SLUTFÖRANDE AV KÖP OCH PROGRAMKRAV. Handelsnamn eller rättigheter associerade
              med alla varumärken på denna webbplats tillhör respektive ägare och är inte anslutna
              till denna kampanj.
            </div>
          </div>
          <br />
        </div>

        <div className="rewards-additional-info"></div>
      </div>
    </div>
  );
};

export default PromosBody;
